export default __webpack_public_path__ + "static/media/4.7cbf5f81.jpg";